import { render, staticRenderFns } from "./ib-button-submit.vue?vue&type=template&id=138df6bc&lang=pug&"
import script from "./ib-button-submit.vue?vue&type=script&lang=js&"
export * from "./ib-button-submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ib-button-submit.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('138df6bc')) {
      api.createRecord('138df6bc', component.options)
    } else {
      api.reload('138df6bc', component.options)
    }
    module.hot.accept("./ib-button-submit.vue?vue&type=template&id=138df6bc&lang=pug&", function () {
      api.rerender('138df6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button/ib-button-submit.vue"
export default component.exports